<div *transloco="let transloco" class="invoice-summary">
  <h2>{{ transloco('InvoiceSummary') }}</h2>
  <hr class="sep">

  <index-grid class="invoice-summary-box">
    <index-grid-column class="address-box" size="6"  child-vertical-alignment="bottom" child-horizontal-alignment="center" class="flex-col justify-between h-auto">
      <div>
        <h3>{{ invoicing.businessName }}</h3>
        <address>
          <p *ngIf="location?.address"><span [innerHTML]="location?.address"></span></p>
          <p *ngIf="location?.phone">{{ location?.phone }}</p>
          <p *ngIf="location?.email">{{ location?.email }}</p>
        </address>
      </div>

      <div class="customer-info">
        <h3> </h3>
        <p><strong>{{ invoice?.firstName }} {{ invoice?.lastName }}</strong></p>
        <index-grid class="px-0">
          <index-grid-column no-flex child-horizontal-alignment="left">
            <address>
              <p *ngIf="invoice?.businessName">{{ invoice?.businessName }}</p>
              <p *ngIf="invoice?.address"><span [innerHTML]="invoice?.address"></span></p>
            </address>
          </index-grid-column>
          <index-grid-column no-flex child-horizontal-alignment="left">
            <p *ngIf="invoice?.phoneNumber">{{ invoice?.phoneNumber }}</p>
          </index-grid-column>
        </index-grid>
        <index-grid class="px-0 py-1 pr-1">
          <index-grid-column no-flex child-horizontal-alignment="left">
            <p *ngIf="invoice?.emailAddress" class="email-address">{{ invoice?.emailAddress }}</p>
          </index-grid-column>
        </index-grid>
      </div>
    </index-grid-column>

    <index-grid-column size="6"  child-vertical-alignment="bottom" child-horizontal-alignment="right" class="flex-col">
      <index-grid class="date-box">
        <index-grid-column no-flex child-horizontal-alignment="left">
          <h3>{{ transloco('SentDate') }}</h3>
          <p>{{ invoice?.localFirstSentDateTime }}</p>
        </index-grid-column>
        <index-grid-column no-flex  child-horizontal-alignment="center">
          <h3>{{ transloco('InvoiceNumber') }}</h3>
          <p>{{ invoice?.invoiceNumber }}</p>
        </index-grid-column>
        <index-grid-column no-flex  child-horizontal-alignment="center">
          <h3>{{ transloco('DueDate') }}</h3>
          <p>{{ invoice?.dueDate }}</p>
        </index-grid-column>
      </index-grid>
      
      <div *ngIf="transaction?.transactionNotes?.length" class="note-box">
        <h3 class="mb-2">{{ transloco('Note') }}</h3>
        <ng-container *ngFor="let note of transaction?.transactionNotes">
            <p *ngIf="note.note !== null" class="normal-case">{{ note.note }}</p>
        </ng-container>
      </div>

      <div class="due-box">
        <div class="due-box__item">
          <span>{{ transloco('Total') }} : </span>
          <span class="currency">{{transaction?.grandTotal}}</span>
        </div>

        <div class="due-box__item">
          <span>{{ transloco('Paid') }} : </span>
          <span class="currency">{{transaction?.tendersTotalAmount}}</span>
        </div>
        <hr>
        <div class="due-box__item">
          <span><b>{{ transloco('Due') }} : </b></span>
          <span><b class="currency">{{transaction?.balanceDueCurrencyFormat}}</b></span>
        </div>
      </div>

    </index-grid-column>
  </index-grid>
</div>

<hr class="sep">

<h3 class="subheading">{{ 'SelectPaymentMethod' | transloco }}</h3>
<div class="payment-section md:flex md:flex-row">
  <div class="payment-section__payment-buttons md:flex-none md:mr-40">
    <index-button (click)="activePaymentType = 'credit-card'" type="secondary" size="full" icon-left [ngClass]="{'active': activePaymentType === 'credit-card'}" class="credit-card-btn">
      <index-icon name="credit-card" weight="light"></index-icon>&nbsp; {{ 'CreditCard' | transloco }}
    </index-button>
    <index-button (click)="activePaymentType = 'gift-card'" type="secondary" size="full" icon-left [ngClass]="{'active': activePaymentType === 'gift-card'}" class="gift-card-btn">
      <index-icon name="gift-card" weight="light"></index-icon>&nbsp; {{ 'GiftCard' | transloco }}
    </index-button>
  </div>

  <div class="payment-section__payment-form md:flex-auto">
    <app-credit-card-form *ngIf="activePaymentType === 'credit-card'" (submitForm)="paymentCallback($event)" (buttonClick)="paymentCallInProgress($event)" [amount]="amount"></app-credit-card-form>  
    <app-gift-card-form *ngIf="activePaymentType === 'gift-card'" (submitForm)="paymentCallback($event)" (buttonClick)="paymentCallInProgress($event)" [amount]="amount"></app-gift-card-form> 
  </div>
</div>

<app-alert-box *ngIf="showAlert" [type]="alertType" (buttonClicked)="alertButtonListener($event)" [messageLine]="alertMessage" [showSpinner]="showSpinner" [buttonText]="alertButtonText"></app-alert-box>
